// extracted by mini-css-extract-plugin
module.exports = {"root":"loginPage_root__KFfhR","form":"loginPage_form__FDcv_"};